import { defineComponent, ref, onMounted, getCurrentInstance } from "vue";
export default defineComponent({
    name: "DemoManagement",
    setup: function setup(props) {
        var instance = getCurrentInstance();
        var root = instance === null || instance === void 0 ? void 0 : instance.proxy;
        var activeIndex = ref("list");
        onMounted(function() {
            activeIndex.value = root.$route.path.substr(root.$route.path.lastIndexOf("/") + 1);
        });
        return {
            activeIndex: activeIndex
        };
    }
});
